enum Status {
  Active = 'active',
  Expired = 'expired',
  Scheduled = 'scheduled',
}

export default Status;
